module.exports = __webpack_public_path__ + "img/arrow.99c69b19.svg";